import Vue                      from "vue";
import Loading                  from "../lib/loading";
import Paginate                 from 'vuejs-paginate';


//Global Component
Vue.component("loading", Loading);

Vue.component('paginate', Paginate);
